import { useContextMenuMESF } from "@dexteel/mesf-core";
import { Grid, Typography } from "@mui/material";
import {
  DefaultMenuItem,
  GetContextMenuItemsParams,
  GridApi,
  MenuItemDef,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CenteredLazyLoading } from "../../../../../controls/LazyLoading";
import { useGridDefinitions } from "../../../../../controls/ag-grid/components/GridDefinitions";
import { FooterButton } from "../../../../../controls/buttons/FooterButton";
import { useCraneOptionsFunctions } from "../hooks/useCraneOptionsFunctions";
import { useTableData } from "../hooks/useTableData";
import { CraneModal } from "./CraneModal";
import type { CatCrane } from "../../../models/CatCrane";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";
import { GRID_DIMENSIONS } from "@/utils/constants";

type onModalHideProps = {
  entityId?: string;
  shouldUpdate?: boolean;
};

type Props = {
  craneCode: string | undefined;
  refetch: Function;
  isLoading: boolean;
};

export const TableCrane = ({ craneCode, refetch, isLoading }: Props) => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState<"new" | "edit" | "delete" | "">(
    "",
  );
  const [crane, setCrane] = useState<CatCrane | null>(null);
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  const { showContextMenu, registerConfig } = useContextMenuMESF();

  const handleNewCrane = () => {
    if (gridApi) gridApi.deselectAll();
    setShowModal("new");
    setCrane(null);
  };

  // const { getMenuOptions } = useCraneOptionsFunctions({
  //   setCrane,
  //   setShowModal,
  //   handleNewCrane,
  // });

  const { rows, columnDefs } = useTableData({
    setCrane,
    setShowModal,
    showContextMenu,
  });

  // const { columnSimpleDefaults } = useGridDefinitions({
  //   OnEdit: (data: any) => {
  //     setShowModal("edit");
  //     setCrane(data);
  //   },
  // });

  const onRowDoubleClicked = (event: any) => {
    const cell = gridApi?.getFocusedCell();
    if (cell?.column.getColId() !== "-" && event.node.isSelected()) {
      setCrane(event.data as CatCrane);
      setShowModal("edit");
    }
  };

  const onCellClicked = (event: any) => {
    if (event.column.colId === "-")
      navigate(`/configuration/byi-cranes/${(event.data as CatCrane).Name}`);
  };

  const onModalHide = ({ entityId, shouldUpdate }: onModalHideProps) => {
    if (entityId && shouldUpdate) {
      setTimeout(() => {
        const rowNode = gridApi?.getRowNode(String(entityId));
        if (rowNode) {
          gridApi?.ensureIndexVisible(rowNode.rowIndex ?? 0, "middle");
          rowNode?.setSelected(true);
        }
      }, 0);
    }
    setShowModal("");
    setCrane(null);
    navigate(`/configuration/byi-cranes/`);
  };

  useEffect(() => {
    if (isLoading) {
      gridApi?.showLoadingOverlay();
    } else {
      gridApi?.hideOverlay();
      if (craneCode && craneCode !== "new") {
        gridApi?.forEachNode((node) => {
          if (node.data?.CraneCode === craneCode) {
            gridApi?.ensureIndexVisible(node.rowIndex ?? 0, "middle");
            node.setSelected(true);
            setCrane(node.data);
            setShowModal("edit");
            return true;
          }
        });
      } else if (craneCode === "new") {
        handleNewCrane();
      }
    }
  }, [isLoading, gridApi]);

  // useEffect(() => {
  //   registerConfig({
  //     id: "craneContext",
  //     getOptions: getMenuOptions,
  //   });
  // }, []);

  return (
    <>
      <Grid container justifyContent="center">
        <Grid item md={12} xs={12} style={{ padding: "0 15px" }}>
          <Typography
            variant="h5"
            style={{ margin: "1px 0 10px", fontWeight: 600 }}
          >
            Cranes
          </Typography>
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ width: "100%", padding: "0 15px" }}
        >
          <div style={{ width: "100%", height: "70vh" }}>
            <AgGridReact<CatCrane>
              rowData={rows || []}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              {...defaultGridOptions}
              // getContextMenuItems={getContextMenuItems}
              onRowDoubleClicked={onRowDoubleClicked}
              onGridReady={(params) => setGridApi(params.api)}
              getRowId={(params) => String(params.data.Name)}
              loadingOverlayComponent={CenteredLazyLoading}
              onCellClicked={onCellClicked}
            />
          </div>
          {/* <FooterButton label="CRANE" onClick={handleNewCrane} /> */}
        </Grid>
      </Grid>
      <CraneModal
        crane={crane}
        showModal={showModal}
        onHide={({ entityId, shouldUpdate }) => {
          onModalHide({ entityId, shouldUpdate });
          if (shouldUpdate) refetch();
        }}
        refreshData={refetch}
      />
    </>
  );
};
